/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { LastOpenedFeature } from '../models/last-opened-feature';
import { LoadcellCommentDto } from '../models/loadcell-comment-dto';
import { LoadcellCommentDtoBaseResponse } from '../models/loadcell-comment-dto-base-response';
import { LoadcellCommentDtoListBaseResponse } from '../models/loadcell-comment-dto-list-base-response';
import { LoadcellHistoryDto } from '../models/loadcell-history-dto';
import { LoadcellInformationResponseDlmBaseResponse } from '../models/loadcell-information-response-dlm-base-response';
import { LoadcellResponse } from '../models/loadcell-response';
import { LoadcellResponseListDlmBaseResponse } from '../models/loadcell-response-list-dlm-base-response';
import { SiteOrigin } from '../models/site-origin';
import { StatusNullableDlmBaseResponse } from '../models/status-nullable-dlm-base-response';
import { TeamRole } from '../models/team-role';
import { TestMachine } from '../models/test-machine';

@Injectable({
  providedIn: 'root',
})
export class RepairsAndCalibrationsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsLoadcellsGet
   */
  static readonly ApiRepairsAndCalibrationsLoadcellsGetPath = '/api/RepairsAndCalibrations/loadcells';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsLoadcellsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsLoadcellsGet$Plain$Response(params?: {
    filterText?: string;
    userId?: number;

    /**
     * 0 &#x3D; Stores
     * 
     * 1 &#x3D; Procurement
     * 
     * 2 &#x3D; Sales
     * 
     * 3 &#x3D; Operations
     * 
     * 4 &#x3D; MachineShop
     */
    teamRole?: TeamRole;
    isDashboard?: boolean;
    isAssigned?: boolean;
  }): Observable<StrictHttpResponse<LoadcellResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsLoadcellsGetPath, 'get');
    if (params) {
      rb.query('filterText', params.filterText, {});
      rb.query('userId', params.userId, {});
      rb.query('teamRole', params.teamRole, {});
      rb.query('isDashboard', params.isDashboard, {});
      rb.query('isAssigned', params.isAssigned, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadcellResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsLoadcellsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsLoadcellsGet$Plain(params?: {
    filterText?: string;
    userId?: number;

    /**
     * 0 &#x3D; Stores
     * 
     * 1 &#x3D; Procurement
     * 
     * 2 &#x3D; Sales
     * 
     * 3 &#x3D; Operations
     * 
     * 4 &#x3D; MachineShop
     */
    teamRole?: TeamRole;
    isDashboard?: boolean;
    isAssigned?: boolean;
  }): Observable<LoadcellResponseListDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsLoadcellsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<LoadcellResponseListDlmBaseResponse>) => r.body as LoadcellResponseListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsLoadcellsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsLoadcellsGet$Json$Response(params?: {
    filterText?: string;
    userId?: number;

    /**
     * 0 &#x3D; Stores
     * 
     * 1 &#x3D; Procurement
     * 
     * 2 &#x3D; Sales
     * 
     * 3 &#x3D; Operations
     * 
     * 4 &#x3D; MachineShop
     */
    teamRole?: TeamRole;
    isDashboard?: boolean;
    isAssigned?: boolean;
  }): Observable<StrictHttpResponse<LoadcellResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsLoadcellsGetPath, 'get');
    if (params) {
      rb.query('filterText', params.filterText, {});
      rb.query('userId', params.userId, {});
      rb.query('teamRole', params.teamRole, {});
      rb.query('isDashboard', params.isDashboard, {});
      rb.query('isAssigned', params.isAssigned, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadcellResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsLoadcellsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsLoadcellsGet$Json(params?: {
    filterText?: string;
    userId?: number;

    /**
     * 0 &#x3D; Stores
     * 
     * 1 &#x3D; Procurement
     * 
     * 2 &#x3D; Sales
     * 
     * 3 &#x3D; Operations
     * 
     * 4 &#x3D; MachineShop
     */
    teamRole?: TeamRole;
    isDashboard?: boolean;
    isAssigned?: boolean;
  }): Observable<LoadcellResponseListDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsLoadcellsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<LoadcellResponseListDlmBaseResponse>) => r.body as LoadcellResponseListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsEditLoadcellsPost
   */
  static readonly ApiRepairsAndCalibrationsEditLoadcellsPostPath = '/api/RepairsAndCalibrations/edit-loadcells';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsEditLoadcellsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsEditLoadcellsPost$Plain$Response(params?: {
    userName?: string;

    /**
     * 0 &#x3D; MyTasks
     * 
     * 1 &#x3D; Workshop
     * 
     * 2 &#x3D; Servicing
     * 
     * 3 &#x3D; LoadcellInformation
     * 
     * 4 &#x3D; AutomaticProcessing
     */
    siteOrigin?: SiteOrigin;
    body?: Array<LoadcellResponse>
  }): Observable<StrictHttpResponse<LoadcellResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsEditLoadcellsPostPath, 'post');
    if (params) {
      rb.query('userName', params.userName, {});
      rb.query('siteOrigin', params.siteOrigin, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadcellResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsEditLoadcellsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsEditLoadcellsPost$Plain(params?: {
    userName?: string;

    /**
     * 0 &#x3D; MyTasks
     * 
     * 1 &#x3D; Workshop
     * 
     * 2 &#x3D; Servicing
     * 
     * 3 &#x3D; LoadcellInformation
     * 
     * 4 &#x3D; AutomaticProcessing
     */
    siteOrigin?: SiteOrigin;
    body?: Array<LoadcellResponse>
  }): Observable<LoadcellResponseListDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsEditLoadcellsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<LoadcellResponseListDlmBaseResponse>) => r.body as LoadcellResponseListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsEditLoadcellsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsEditLoadcellsPost$Json$Response(params?: {
    userName?: string;

    /**
     * 0 &#x3D; MyTasks
     * 
     * 1 &#x3D; Workshop
     * 
     * 2 &#x3D; Servicing
     * 
     * 3 &#x3D; LoadcellInformation
     * 
     * 4 &#x3D; AutomaticProcessing
     */
    siteOrigin?: SiteOrigin;
    body?: Array<LoadcellResponse>
  }): Observable<StrictHttpResponse<LoadcellResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsEditLoadcellsPostPath, 'post');
    if (params) {
      rb.query('userName', params.userName, {});
      rb.query('siteOrigin', params.siteOrigin, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadcellResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsEditLoadcellsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsEditLoadcellsPost$Json(params?: {
    userName?: string;

    /**
     * 0 &#x3D; MyTasks
     * 
     * 1 &#x3D; Workshop
     * 
     * 2 &#x3D; Servicing
     * 
     * 3 &#x3D; LoadcellInformation
     * 
     * 4 &#x3D; AutomaticProcessing
     */
    siteOrigin?: SiteOrigin;
    body?: Array<LoadcellResponse>
  }): Observable<LoadcellResponseListDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsEditLoadcellsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<LoadcellResponseListDlmBaseResponse>) => r.body as LoadcellResponseListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost
   */
  static readonly ApiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePostPath = '/api/RepairsAndCalibrations/set-loadcell-last-opened-feature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost$Plain$Response(params?: {
    loadcellId?: number;

    /**
     * 0 &#x3D; CommentsTab
     * 
     * 1 &#x3D; CustomerTab
     * 
     * 2 &#x3D; PreliminaryTab
     * 
     * 3 &#x3D; FaultTab
     * 
     * 4 &#x3D; CalibrationTab
     * 
     * 5 &#x3D; QuotationCertificate
     * 
     * 6 &#x3D; ExaminationReport
     * 
     * 7 &#x3D; CalibrationCertificate
     * 
     * 8 &#x3D; EditCalibration
     * 
     * 9 &#x3D; DispatchNotesTab
     */
    feature?: LastOpenedFeature;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePostPath, 'post');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
      rb.query('feature', params.feature, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost$Plain(params?: {
    loadcellId?: number;

    /**
     * 0 &#x3D; CommentsTab
     * 
     * 1 &#x3D; CustomerTab
     * 
     * 2 &#x3D; PreliminaryTab
     * 
     * 3 &#x3D; FaultTab
     * 
     * 4 &#x3D; CalibrationTab
     * 
     * 5 &#x3D; QuotationCertificate
     * 
     * 6 &#x3D; ExaminationReport
     * 
     * 7 &#x3D; CalibrationCertificate
     * 
     * 8 &#x3D; EditCalibration
     * 
     * 9 &#x3D; DispatchNotesTab
     */
    feature?: LastOpenedFeature;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost$Json$Response(params?: {
    loadcellId?: number;

    /**
     * 0 &#x3D; CommentsTab
     * 
     * 1 &#x3D; CustomerTab
     * 
     * 2 &#x3D; PreliminaryTab
     * 
     * 3 &#x3D; FaultTab
     * 
     * 4 &#x3D; CalibrationTab
     * 
     * 5 &#x3D; QuotationCertificate
     * 
     * 6 &#x3D; ExaminationReport
     * 
     * 7 &#x3D; CalibrationCertificate
     * 
     * 8 &#x3D; EditCalibration
     * 
     * 9 &#x3D; DispatchNotesTab
     */
    feature?: LastOpenedFeature;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePostPath, 'post');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
      rb.query('feature', params.feature, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost$Json(params?: {
    loadcellId?: number;

    /**
     * 0 &#x3D; CommentsTab
     * 
     * 1 &#x3D; CustomerTab
     * 
     * 2 &#x3D; PreliminaryTab
     * 
     * 3 &#x3D; FaultTab
     * 
     * 4 &#x3D; CalibrationTab
     * 
     * 5 &#x3D; QuotationCertificate
     * 
     * 6 &#x3D; ExaminationReport
     * 
     * 7 &#x3D; CalibrationCertificate
     * 
     * 8 &#x3D; EditCalibration
     * 
     * 9 &#x3D; DispatchNotesTab
     */
    feature?: LastOpenedFeature;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsSetLoadcellLastOpenedFeaturePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsDeleteLoadcellPost
   */
  static readonly ApiRepairsAndCalibrationsDeleteLoadcellPostPath = '/api/RepairsAndCalibrations/delete-loadcell';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsDeleteLoadcellPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsDeleteLoadcellPost$Plain$Response(params?: {
    body?: LoadcellResponse
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsDeleteLoadcellPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsDeleteLoadcellPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsDeleteLoadcellPost$Plain(params?: {
    body?: LoadcellResponse
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsDeleteLoadcellPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsDeleteLoadcellPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsDeleteLoadcellPost$Json$Response(params?: {
    body?: LoadcellResponse
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsDeleteLoadcellPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsDeleteLoadcellPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsDeleteLoadcellPost$Json(params?: {
    body?: LoadcellResponse
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsDeleteLoadcellPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsLoadcellInformationGet
   */
  static readonly ApiRepairsAndCalibrationsLoadcellInformationGetPath = '/api/RepairsAndCalibrations/loadcell-information';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsLoadcellInformationGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsLoadcellInformationGet$Plain$Response(params?: {
    loadcellId?: number;
  }): Observable<StrictHttpResponse<LoadcellInformationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsLoadcellInformationGetPath, 'get');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadcellInformationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsLoadcellInformationGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsLoadcellInformationGet$Plain(params?: {
    loadcellId?: number;
  }): Observable<LoadcellInformationResponseDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsLoadcellInformationGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<LoadcellInformationResponseDlmBaseResponse>) => r.body as LoadcellInformationResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsLoadcellInformationGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsLoadcellInformationGet$Json$Response(params?: {
    loadcellId?: number;
  }): Observable<StrictHttpResponse<LoadcellInformationResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsLoadcellInformationGetPath, 'get');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadcellInformationResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsLoadcellInformationGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsLoadcellInformationGet$Json(params?: {
    loadcellId?: number;
  }): Observable<LoadcellInformationResponseDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsLoadcellInformationGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<LoadcellInformationResponseDlmBaseResponse>) => r.body as LoadcellInformationResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsGetStatusByFormIdGet
   */
  static readonly ApiRepairsAndCalibrationsGetStatusByFormIdGetPath = '/api/RepairsAndCalibrations/get-status-by-form-id';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsGetStatusByFormIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsGetStatusByFormIdGet$Plain$Response(params?: {
    form10aId?: number;
  }): Observable<StrictHttpResponse<StatusNullableDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsGetStatusByFormIdGetPath, 'get');
    if (params) {
      rb.query('form10aId', params.form10aId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StatusNullableDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsGetStatusByFormIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsGetStatusByFormIdGet$Plain(params?: {
    form10aId?: number;
  }): Observable<StatusNullableDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsGetStatusByFormIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StatusNullableDlmBaseResponse>) => r.body as StatusNullableDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsGetStatusByFormIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsGetStatusByFormIdGet$Json$Response(params?: {
    form10aId?: number;
  }): Observable<StrictHttpResponse<StatusNullableDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsGetStatusByFormIdGetPath, 'get');
    if (params) {
      rb.query('form10aId', params.form10aId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StatusNullableDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsGetStatusByFormIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsGetStatusByFormIdGet$Json(params?: {
    form10aId?: number;
  }): Observable<StatusNullableDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsGetStatusByFormIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StatusNullableDlmBaseResponse>) => r.body as StatusNullableDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsUpdateInvoiceAddressPost
   */
  static readonly ApiRepairsAndCalibrationsUpdateInvoiceAddressPostPath = '/api/RepairsAndCalibrations/update-invoice-address';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateInvoiceAddressPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateInvoiceAddressPost$Plain$Response(params?: {
    customerLocationId?: number;
    loadcellId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateInvoiceAddressPostPath, 'post');
    if (params) {
      rb.query('customerLocationId', params.customerLocationId, {});
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateInvoiceAddressPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateInvoiceAddressPost$Plain(params?: {
    customerLocationId?: number;
    loadcellId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateInvoiceAddressPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateInvoiceAddressPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateInvoiceAddressPost$Json$Response(params?: {
    customerLocationId?: number;
    loadcellId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateInvoiceAddressPostPath, 'post');
    if (params) {
      rb.query('customerLocationId', params.customerLocationId, {});
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateInvoiceAddressPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateInvoiceAddressPost$Json(params?: {
    customerLocationId?: number;
    loadcellId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateInvoiceAddressPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsUpdateDispatchAddressPost
   */
  static readonly ApiRepairsAndCalibrationsUpdateDispatchAddressPostPath = '/api/RepairsAndCalibrations/update-dispatch-address';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateDispatchAddressPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateDispatchAddressPost$Plain$Response(params?: {
    customerLocationId?: number;
    loadcellId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateDispatchAddressPostPath, 'post');
    if (params) {
      rb.query('customerLocationId', params.customerLocationId, {});
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateDispatchAddressPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateDispatchAddressPost$Plain(params?: {
    customerLocationId?: number;
    loadcellId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateDispatchAddressPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateDispatchAddressPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateDispatchAddressPost$Json$Response(params?: {
    customerLocationId?: number;
    loadcellId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateDispatchAddressPostPath, 'post');
    if (params) {
      rb.query('customerLocationId', params.customerLocationId, {});
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateDispatchAddressPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateDispatchAddressPost$Json(params?: {
    customerLocationId?: number;
    loadcellId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateDispatchAddressPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsUpdateQuoteContactPost
   */
  static readonly ApiRepairsAndCalibrationsUpdateQuoteContactPostPath = '/api/RepairsAndCalibrations/update-quote-contact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateQuoteContactPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateQuoteContactPost$Plain$Response(params?: {
    customerQuoteId?: number;
    loadcellId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateQuoteContactPostPath, 'post');
    if (params) {
      rb.query('customerQuoteId', params.customerQuoteId, {});
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateQuoteContactPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateQuoteContactPost$Plain(params?: {
    customerQuoteId?: number;
    loadcellId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateQuoteContactPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateQuoteContactPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateQuoteContactPost$Json$Response(params?: {
    customerQuoteId?: number;
    loadcellId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateQuoteContactPostPath, 'post');
    if (params) {
      rb.query('customerQuoteId', params.customerQuoteId, {});
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateQuoteContactPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateQuoteContactPost$Json(params?: {
    customerQuoteId?: number;
    loadcellId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateQuoteContactPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsUpdateTestMachinePost
   */
  static readonly ApiRepairsAndCalibrationsUpdateTestMachinePostPath = '/api/RepairsAndCalibrations/update-test-machine';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateTestMachinePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateTestMachinePost$Plain$Response(params?: {
    loadcellId?: number;

    /**
     * 0 &#x3D; Unassigned
     * 
     * 1 &#x3D; GoAhead
     * 
     * 2 &#x3D; One
     * 
     * 3 &#x3D; Sixty
     * 
     * 4 &#x3D; OneHundred
     * 
     * 5 &#x3D; ThreeHundred
     * 
     * 6 &#x3D; Vulcan
     * 
     * 7 &#x3D; Other
     * 
     * 8 &#x3D; CalReportComplete
     * 
     * 9 &#x3D; PressureTest
     * 
     * 10 &#x3D; SalesToProductionHandover
     */
    testMachine?: TestMachine;
    userName?: string;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateTestMachinePostPath, 'post');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
      rb.query('testMachine', params.testMachine, {});
      rb.query('userName', params.userName, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateTestMachinePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateTestMachinePost$Plain(params?: {
    loadcellId?: number;

    /**
     * 0 &#x3D; Unassigned
     * 
     * 1 &#x3D; GoAhead
     * 
     * 2 &#x3D; One
     * 
     * 3 &#x3D; Sixty
     * 
     * 4 &#x3D; OneHundred
     * 
     * 5 &#x3D; ThreeHundred
     * 
     * 6 &#x3D; Vulcan
     * 
     * 7 &#x3D; Other
     * 
     * 8 &#x3D; CalReportComplete
     * 
     * 9 &#x3D; PressureTest
     * 
     * 10 &#x3D; SalesToProductionHandover
     */
    testMachine?: TestMachine;
    userName?: string;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateTestMachinePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateTestMachinePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateTestMachinePost$Json$Response(params?: {
    loadcellId?: number;

    /**
     * 0 &#x3D; Unassigned
     * 
     * 1 &#x3D; GoAhead
     * 
     * 2 &#x3D; One
     * 
     * 3 &#x3D; Sixty
     * 
     * 4 &#x3D; OneHundred
     * 
     * 5 &#x3D; ThreeHundred
     * 
     * 6 &#x3D; Vulcan
     * 
     * 7 &#x3D; Other
     * 
     * 8 &#x3D; CalReportComplete
     * 
     * 9 &#x3D; PressureTest
     * 
     * 10 &#x3D; SalesToProductionHandover
     */
    testMachine?: TestMachine;
    userName?: string;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateTestMachinePostPath, 'post');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
      rb.query('testMachine', params.testMachine, {});
      rb.query('userName', params.userName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateTestMachinePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateTestMachinePost$Json(params?: {
    loadcellId?: number;

    /**
     * 0 &#x3D; Unassigned
     * 
     * 1 &#x3D; GoAhead
     * 
     * 2 &#x3D; One
     * 
     * 3 &#x3D; Sixty
     * 
     * 4 &#x3D; OneHundred
     * 
     * 5 &#x3D; ThreeHundred
     * 
     * 6 &#x3D; Vulcan
     * 
     * 7 &#x3D; Other
     * 
     * 8 &#x3D; CalReportComplete
     * 
     * 9 &#x3D; PressureTest
     * 
     * 10 &#x3D; SalesToProductionHandover
     */
    testMachine?: TestMachine;
    userName?: string;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateTestMachinePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsUpdateInspectedByPost
   */
  static readonly ApiRepairsAndCalibrationsUpdateInspectedByPostPath = '/api/RepairsAndCalibrations/update-inspected-by';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateInspectedByPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateInspectedByPost$Plain$Response(params?: {
    loadcellId?: number;
    employeeId?: number;
    userName?: string;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateInspectedByPostPath, 'post');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
      rb.query('employeeId', params.employeeId, {});
      rb.query('userName', params.userName, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateInspectedByPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateInspectedByPost$Plain(params?: {
    loadcellId?: number;
    employeeId?: number;
    userName?: string;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateInspectedByPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateInspectedByPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateInspectedByPost$Json$Response(params?: {
    loadcellId?: number;
    employeeId?: number;
    userName?: string;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateInspectedByPostPath, 'post');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
      rb.query('employeeId', params.employeeId, {});
      rb.query('userName', params.userName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateInspectedByPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsUpdateInspectedByPost$Json(params?: {
    loadcellId?: number;
    employeeId?: number;
    userName?: string;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateInspectedByPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsSetQuoteEmailedPost
   */
  static readonly ApiRepairsAndCalibrationsSetQuoteEmailedPostPath = '/api/RepairsAndCalibrations/set-quote-emailed';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsSetQuoteEmailedPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsSetQuoteEmailedPost$Plain$Response(params?: {
    quoteId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsSetQuoteEmailedPostPath, 'post');
    if (params) {
      rb.query('quoteId', params.quoteId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsSetQuoteEmailedPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsSetQuoteEmailedPost$Plain(params?: {
    quoteId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsSetQuoteEmailedPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsSetQuoteEmailedPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsSetQuoteEmailedPost$Json$Response(params?: {
    quoteId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsSetQuoteEmailedPostPath, 'post');
    if (params) {
      rb.query('quoteId', params.quoteId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsSetQuoteEmailedPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsSetQuoteEmailedPost$Json(params?: {
    quoteId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiRepairsAndCalibrationsSetQuoteEmailedPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsAddHistoryPost
   */
  static readonly ApiRepairsAndCalibrationsAddHistoryPostPath = '/api/RepairsAndCalibrations/add-history';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsAddHistoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsAddHistoryPost$Plain$Response(params?: {
    body?: LoadcellHistoryDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsAddHistoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsAddHistoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsAddHistoryPost$Plain(params?: {
    body?: LoadcellHistoryDto
  }): Observable<BooleanBaseResponse> {

    return this.apiRepairsAndCalibrationsAddHistoryPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsAddHistoryPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsAddHistoryPost$Json$Response(params?: {
    body?: LoadcellHistoryDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsAddHistoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsAddHistoryPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsAddHistoryPost$Json(params?: {
    body?: LoadcellHistoryDto
  }): Observable<BooleanBaseResponse> {

    return this.apiRepairsAndCalibrationsAddHistoryPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsCommentsGet
   */
  static readonly ApiRepairsAndCalibrationsCommentsGetPath = '/api/RepairsAndCalibrations/comments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsCommentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsCommentsGet$Plain$Response(params?: {
    loadcellId?: number;
  }): Observable<StrictHttpResponse<LoadcellCommentDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsCommentsGetPath, 'get');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadcellCommentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsCommentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsCommentsGet$Plain(params?: {
    loadcellId?: number;
  }): Observable<LoadcellCommentDtoListBaseResponse> {

    return this.apiRepairsAndCalibrationsCommentsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<LoadcellCommentDtoListBaseResponse>) => r.body as LoadcellCommentDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsCommentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsCommentsGet$Json$Response(params?: {
    loadcellId?: number;
  }): Observable<StrictHttpResponse<LoadcellCommentDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsCommentsGetPath, 'get');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadcellCommentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsCommentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsCommentsGet$Json(params?: {
    loadcellId?: number;
  }): Observable<LoadcellCommentDtoListBaseResponse> {

    return this.apiRepairsAndCalibrationsCommentsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<LoadcellCommentDtoListBaseResponse>) => r.body as LoadcellCommentDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsAddCommentPost
   */
  static readonly ApiRepairsAndCalibrationsAddCommentPostPath = '/api/RepairsAndCalibrations/add-comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsAddCommentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsAddCommentPost$Plain$Response(params?: {
    body?: LoadcellCommentDto
  }): Observable<StrictHttpResponse<LoadcellCommentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsAddCommentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadcellCommentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsAddCommentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsAddCommentPost$Plain(params?: {
    body?: LoadcellCommentDto
  }): Observable<LoadcellCommentDtoBaseResponse> {

    return this.apiRepairsAndCalibrationsAddCommentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<LoadcellCommentDtoBaseResponse>) => r.body as LoadcellCommentDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsAddCommentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsAddCommentPost$Json$Response(params?: {
    body?: LoadcellCommentDto
  }): Observable<StrictHttpResponse<LoadcellCommentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsAddCommentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadcellCommentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsAddCommentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsAddCommentPost$Json(params?: {
    body?: LoadcellCommentDto
  }): Observable<LoadcellCommentDtoBaseResponse> {

    return this.apiRepairsAndCalibrationsAddCommentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<LoadcellCommentDtoBaseResponse>) => r.body as LoadcellCommentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsUpdateCommentPut
   */
  static readonly ApiRepairsAndCalibrationsUpdateCommentPutPath = '/api/RepairsAndCalibrations/update-comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateCommentPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsUpdateCommentPut$Plain$Response(params?: {
    body?: LoadcellCommentDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateCommentPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateCommentPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsUpdateCommentPut$Plain(params?: {
    body?: LoadcellCommentDto
  }): Observable<BooleanBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateCommentPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsUpdateCommentPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsUpdateCommentPut$Json$Response(params?: {
    body?: LoadcellCommentDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsUpdateCommentPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsUpdateCommentPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRepairsAndCalibrationsUpdateCommentPut$Json(params?: {
    body?: LoadcellCommentDto
  }): Observable<BooleanBaseResponse> {

    return this.apiRepairsAndCalibrationsUpdateCommentPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsDeleteCommentDelete
   */
  static readonly ApiRepairsAndCalibrationsDeleteCommentDeletePath = '/api/RepairsAndCalibrations/delete-comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsDeleteCommentDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsDeleteCommentDelete$Plain$Response(params?: {
    commentId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsDeleteCommentDeletePath, 'delete');
    if (params) {
      rb.query('commentId', params.commentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsDeleteCommentDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsDeleteCommentDelete$Plain(params?: {
    commentId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiRepairsAndCalibrationsDeleteCommentDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsDeleteCommentDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsDeleteCommentDelete$Json$Response(params?: {
    commentId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsDeleteCommentDeletePath, 'delete');
    if (params) {
      rb.query('commentId', params.commentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsDeleteCommentDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsDeleteCommentDelete$Json(params?: {
    commentId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiRepairsAndCalibrationsDeleteCommentDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet
   */
  static readonly ApiRepairsAndCalibrationsProcessLoadcellSwimlanesGetPath = '/api/RepairsAndCalibrations/process-loadcell-swimlanes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsProcessLoadcellSwimlanesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet$Plain(params?: {
  }): Observable<number> {

    return this.apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, RepairsAndCalibrationsService.ApiRepairsAndCalibrationsProcessLoadcellSwimlanesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet$Json(params?: {
  }): Observable<number> {

    return this.apiRepairsAndCalibrationsProcessLoadcellSwimlanesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
